<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100;">
            {{ hasEditPermission ? 'EDIT' : 'VIEW'}} PETTY CASH ENTRY {{ (form && form.hasOwnProperty('number') && form.number) ? form.number : '' }}
            ({{
              originalHeader && originalHeader.hasOwnProperty('status') && originalHeader.status
                ? originalHeader.status
                : ''
            }})
          </h2>
        </el-row>
      </el-col>
      <template>
        <el-button :disabled="disablePrevButton || isSaving" :loading="loadingPrev" @click.stop="pageNavigation('prev')" size="small">Previous</el-button>
        <el-button :disabled="disableNextButton || isSaving" class="mr-5" :loading="loadingNext" @click.stop="pageNavigation('next')" size="small">Next</el-button>
      </template>
      <DataEntryButtons
        :status="originalHeader.status"
        :isReadOnly="readOnly"
        :hasBeenChanged="getUpdatedFieldsExcluding"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :isSaveable="isSaveable"
        :disableDistChanges="disableDistChanges"
        :dropdownStatuses="['DRAFT', 'CLOSED', 'POSTED', 'VOIDED']"
        :saveAndAuditStatuses="['OPEN', 'AUDITED']"
        :saveAndPostStatuses="['OPEN', 'AUDITED']"
        :saveOnlyStatuses="['POSTED', 'OPEN', 'AUDITED', 'CLOSED']"
        :disableAuditBtn="disableAuditBtn"
        :disablePostBtn="disablePostBtn"
        :postBtnStatuses="['OPEN', 'AUDITED']"
        :transactionType="transactionType"
        :parentForm="form"
        :numberOfFiles="numberOfFiles"
        :isRecon="isRecon"
        :hasDcs="hasDcs"
        :hasPermission="hasPermission"
        @addNew="addNew"
        @toggleReadOnly="toggleReadOnly"
        @dropdownClick="handleDropdownClick"
        @goBack="goBack"
        @auditBtnClick="handleAuditBtnClick('Petty Cash')"
        @postBtnClick="handlePostBtnClick('Petty Cash')"
        @otherActions="otherActions"
        @submit="handleSubmit"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
      <el-row justify="start" align="top" type="flex" class="trx-header" ref="trxHeaderContainer">
      <el-col :span="8" style="margin-right: 10px">
        <el-row justify="start" align="top" type="flex">
          <HeaderFields
            title="Vendor"
            :fields="fields.vendor"
            v-model:form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            :linesContainReliefLines="linesContainReliefLines"
            @formChanged="updateForm"
          />
        </el-row>
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            v-model:form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="padding: 0 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Petty Cash Data"
            :fields="fields.pcData"
            v-model:form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @acBackspaceEvent="updateForm"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="padding-left: 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Info"
            :fields="fields.transactionInfo"
            v-model:form="form"
            :lines="lines"
            :idPrefix="'d-'"
            :modalOpen="dialogVisible"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="pc"
        ref="distribution-lines"
        :fields="lineFields"
        :readOnly="readOnly || isSaving"
        :existingLines="[...originalLines]"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :initLines="20"
        :vendorPoLines="vendorPoLines"
        :fetchingPoLines="fetchingPoData"
        :fieldsToClear="lineFieldsToClear"
        :hasEditPermission="hasEditPermission"
        :hasDeletePermission="hasDeletePermission"
        @viewDc="viewDc"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @updateLines="updateLines"
        @mounted="addEnvelopeLineItem"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      v-model="dialogVisible"
      width="30%"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Do you wish to save your changes?
      </span>
      <template v-slot:footer><span class="dialog-footer">
        <el-button class="exit-modal-btn" @click="cancelExit">
          Cancel
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="goBack(true)">
          No
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="handleSubmit(false)">
          Yes
        </el-button>
      </span></template>
    </el-dialog>
    <el-dialog
      id="docs-dialog"
      title="View/Upload Documents"
      width="45%"
      top="10%"
      v-model="dropzoneVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <document-dialog
        :transaction="form"
        :dz-options="setupDropzoneOptions()"
        @upload-success="dzSuccess"
        @upload-error="dzFailure"
        @upload-remove="dzRemove"
      />
    </el-dialog>
    <NewBatch :hasCreatePermission="hasCreateBatchPermission" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <CustomerVendorForm :type="customerVendorFormType" :modelId="modelId" @updateModelIdProp="updateVendorModelId" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <DcConfirmationDialog
      :originalLines="originalLines"
      :lineDeltas="lineDeltas"
      :lineFields="lineFields"
      v-model="dcConfirmationDialogVisible"
      :allDcs="allDcs"
      :newDcs="newDcs"
      :existingDcs="existingDcs"
      :loading="creatingDc"
      @cancel="() => showDcConfirmationDialog(false)"
      @confirm="confirmDcSubmit"
    />
    <DcViewDialog
      :viewedDcId="viewedDcId"
      :viewableDcs="viewableDcs"
      :showOrClose="viewDc"
      :trxType="transactionType.name"
      :lineFields="lineFields"
      :trxId="originalHeader.id"
    />
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  /* eslint-disable no-return-assign */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew1.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import CustomerVendorForm from '@/components/FormComponents/CustomerVendorForm.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import { isPcBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { trackHeaderChanges, trackDistributionChanges } from '@/utils/helpers/DataEntryViews/TrackChanges'
  // import sortLines from '@/utils/helpers/DataEntryViews/SortLines'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { transactionEditViewMixins } from '@/Mixins/TransactionEditViews'
  import { vendorMixins } from '@/Mixins/VendorMixins'
  import { pettycashMixins } from '@/Mixins/PettyCash'
  import buildLabelString from '@/utils/helpers/BuildLabelString'
  import DocumentDialog from '@/components/DocumentDialog.vue'
  import LinesLoading from '@/components/LinesLoading.vue'
  import FindOrFetchBatchAndPeriod from '@/utils/helpers/DataEntryViews/FindOrFetchBatchAndPeriod'
  import store from '@/store/store'
  import DcConfirmationDialog from '@/components/DcConfirmationDialog'
  import DcViewDialog from '@/components/DcViewDialog.vue'
  import { getPoLinesToRelieve, getOffsetDcJeLines, loadInitialData } from '@/utils/helpers/DataEntryViews/BeforeRouteEnterHelpers'

  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      CustomerVendorForm,
      DataEntryButtons,
      DocumentDialog,
      LinesLoading,
      DcConfirmationDialog,
      DcViewDialog
    },
    mixins: [ transactionMixins, transactionEditViewMixins, pettycashMixins, vendorMixins ],
    data () {
      const { getPcById, getPcLinesByTransactionId, getBatchById, getVendorById, checkIfUserHasRequiredPermissions } = this.$store.getters
      const pc = getPcById(this.$route.params.id)
      const vendor = getVendorById(pc.vendor)
      let lines = this.buildLinesWithDcs(Object.values(getPcLinesByTransactionId(pc.id)))
      return {
        modelId: null,
        transactionType: { name: 'pc', path: '/pettycash/', prettyName: 'Petty Cash' },
        originalHeader: pc,
        originalLines: lines,
        form: {
          batch: { label: getBatchById(pc.batch)?.name || '', value: pc.batch || '' },
          vendor: { label: buildLabelString(vendor), value: pc.vendor || '' },
          period: pc.period || '',
          number: pc.number || '',
          description: pc.description || '',
          date: pc.date || '',
          amount_decimal: pc.amount_decimal || '',
          advanced_amount_decimal: pc.advanced_amount_decimal || '0.00',
          reimbursed_amount_decimal: pc.reimbursed_amount_decimal || '0.00',
          amount_beginning_pc_decimal: '',
          amount_remaining_pc_decimal: '',
          pcAccount: '',
          status: pc.status,
          effective_date: pc.effective_date || ''
        },
        lines,
        headerDeltas: {},
        lineDeltas: {},
        dialogVisible: false,
        readOnly: !['DRAFT', 'OPEN', 'AUDITED'].includes(pc.status) || (!checkIfUserHasRequiredPermissions(['entry.view_pettycash', 'entry.add_pettycash']) && ['DRAFT', 'OPEN', 'AUDITED'].includes(pc.status)) || (!checkIfUserHasRequiredPermissions(['entry.view_pettycash', 'entry.add_pettycash', 'entry.post_pettycash']) && ['POSTED'].includes(pc.status)),
        changesWereSaved: false,
        transactionIsBalanced: false,
        amountHasChanged: false,
        statusToRestore: '',
        altRoute: null,
        currentVendorSelection: '',
        ready: false,
        disableAuditBtn: false,
        disablePostBtn: false,
        isSaving: false,
        notificationBox: undefined,
        specialPcLines: { envelope: undefined, advance: undefined, reimbursement: undefined },
        dropzoneVisible: false,
        disablePrevButton: true,
        disableNextButton: true,
        loadingPrev: false,
        loadingNext: false,
        paginationData: []
      }
    },
    methods: {
      /**
       * Updates modelId prop passed to customer create/edit modal
       */
      updateVendorModelId (id) {
        this.modelId = id
      },
      goBack (reset = false) {
        if (reset) this.hasBeenChanged = false
        this.ready = false
        if (this.altRoute && Object.keys(this.altRoute).length) {
          this.$router.push(this.altRoute)
        } else {
          this.$router.push({ name: 'PCs' })
        }
      },
      /**
       * Submits the form.
       * @param saveOnly Enables or disables any navigation that should occur after the transaction is saved
       * @param explicitDeltas Specifies hard-coded deltas that need to be set, such as status
       * @param reportToRun Specifies type of report to run once saved. Can be 'audit' or 'posting'
       */
      handleSubmit (saveOnly, explicitDeltas = null, reportToRun = null) {
        if (this.$refs['distribution-lines'].errors.length) {
          this.$notify({ title: 'Error saving distribution changes', message: 'Incomplete lines', type: 'error' })
          return
        }
        if (this.shouldCreateDcJe) {
          this.showDcConfirmationDialog(true)
          return
        }
        if (this.dialogVisible) this.handleDialogVisible(false)   // Close any open dialog boxes
        let removedLines = this.removeDeletedLines()
        const { headerDeltas, lineDeltas } = this
        if (explicitDeltas) this.headerDeltas = Object.assign(headerDeltas, explicitDeltas)
        const hDeltaCount = Object.keys(headerDeltas).length
        const lDeltaCount = Object.keys(lineDeltas).length
        if (hDeltaCount || lDeltaCount) {
          this.isSaving = true
          this.saveTransactionChanges('Pc', saveOnly, reportToRun)
        } else {
          this.transactionIsBalanced = isPcBalanced(this)
          this.checkForChanges()
          if (removedLines.length) {
            removedLines.forEach(lineNum => this.$refs['distribution-lines'].removeLine(lineNum))
          }
        }
      },
      /**
       * Updates distribution lines
       * @param lines
       */
      updateLines (lines) {
        this.lines = lines
        this.linesChanged()
      },
      /**
       * Updates header form
       * @param form
       * @param changedField
       */
      updateForm (form, changedField = null) {
        this.form = { ...form }
        this.transactionIsBalanced = isPcBalanced(this)
        this.headerDeltas = trackHeaderChanges(this.form, this.originalHeader)
        this.checkForChanges()
        if (changedField === 'vendor') {
          if (this.linesContainReliefLines) {
            this.clearLineFields(['relieves'])        // check if vendor field was cleared, and if so, clear 'relieves' field in DistributionLines
          }
          if (form.number) this.checkIfTrxExists()
        } else if (changedField === 'batch') {
          this.setPcBalance(this.form.vendor.value, true)  // set selected batch's bank cash account
          if (this.advanced_amount) {
            this.addAdvanceLineItem()
          }
        } else if (changedField === 'reimbursed_amount_decimal') {
          this.isPcReimbursementTransaction = true
        } else if (changedField === 'number') this.checkIfTrxExists()
        if (this.form.vendor.value) {
          this.currentVendorSelection = this.form.vendor.value
        }
        this.trackCustomerNumberChange()
      },
      /**
       * Fires whenever a change is made to a distribution line
       */
      linesChanged () {
        this.lineDeltas = trackDistributionChanges(this.lines, this.originalLines)
        this.transactionIsBalanced = isPcBalanced(this)
        this.checkForChanges()
      },
      /**
       * Updates the header's "status" field
       */
      updateHeaderStatusField () {
        let tmp = Object.assign({}, this.form)
        tmp.status = this.originalHeader.status
        this.form = Object.assign({}, tmp)
      },
      /**
       * Disables header fields
       * TODO: deprecate
       */
      disableHeaderFields () {
        let tmpFields = Object.assign({}, this.fields)
        tmpFields.pcData.inputFields.map(v => {
          if ([ 'amount_decimal', 'advanced_amount_decimal', 'reimbursed_amount_decimal' ].includes(v.name)) v.disabled = true
          return v
        })
        tmpFields.batch.inputFields.map(v => {
          if (v.name === 'batch') {
            v.disabled = true
            v.addBtn = false
          }
          return v
        })
        this.fields = Object.assign({}, tmpFields)
      },
      addEnvelopeLineItem () {
        this.specialPcLines.envelope = this.$refs['distribution-lines']
          .addPettyCashLines('envelope', this.specialPcLines.envelope, true)
      },
      addAdvanceLineItem () {
        this.specialPcLines.advance = this.$refs['distribution-lines']
          .addPettyCashLines('advance', this.specialPcLines.advance)
      },
      addReimbursementLineItem () {
        this.specialPcLines.reimbursement = this.$refs['distribution-lines']
          .addPettyCashLines('reimbursement', this.specialPcLines.reimbursement)
      },
      /**
       * Tracks changes to the envelope number
       */
      trackCustomerNumberChange () {
        this.vendorNumberVerifier = `${this.form.number}`
      },
      async pageNavigation (type) {
        // Get the index of the current AP ( Current route id)
        let transactionIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
        let prevAndNextId = parseInt(this.$route.params.id)
        if (transactionIndex >= 0) {
          // Check Index is greater than zero and type is 'next'
          if (type === 'next') {
            this.loadingNext = true
            // Check upcoming Record is exist or not
            let checkNextId = this.paginationData[transactionIndex + 1]
            if (!checkNextId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkNextId).length) {
              prevAndNextId = checkNextId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'next' button
            this.disableNextButton = !this.paginationData[transactionIndex + 2]
          } else if (type === 'prev') {
            this.loadingPrev = true
            // Check upcoming Record is exist or not
            let checkPrevId = this.paginationData[transactionIndex - 1]
            if (!checkPrevId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkPrevId).length) {
              prevAndNextId = checkPrevId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'previous' button
            this.disablePrevButton = !this.paginationData[transactionIndex - 2]
          }
        }
        // Refresh the data without reloading the page
        this.refreshPage(prevAndNextId)
      },
      // Its copy of 'beforeRouteEnter': To refresh the data
      async refreshPage (routeId) {
        const { getPcById } = store.getters
        try {
          const resp = await store.dispatch('fetchCompactLinePcsWithQuery', { query: { id: routeId, compact_lines: true }, storeLines: true })
          let promises = [
            store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
            store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
          ]
          if (resp && resp.entities) {
            const deps = await store.dispatch('findDependencies', resp.entities) || []
            promises = [...promises, ...deps]
          }
          await Promise.all(promises)
          const pc = getPcById(routeId)
          // Prefetch vendor so it's cached before data() builds the label (parity with batch prefetch).
          if (pc && pc.vendor) await store.dispatch('fetchVendorById', pc.vendor)
          await getPoLinesToRelieve(pc.id, 'pc')
          if (['POSTED', 'CLOSED', 'VOIDED', 'DELETED'].includes(pc.status)) {
            await getOffsetDcJeLines(routeId, 'pc')
          }
          promises = [...FindOrFetchBatchAndPeriod(store, pc)]
          if (promises.length) {
            await Promise.all(promises)
          }
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
        } catch (e) {
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
          console.log(e)
        }
      },
      async customCreated () {
        // To Prepare Query params to pass to the API
        const activeTab = store.getters.getActiveTab || 'all'
        let selectedStatuses = ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'VOIDED', 'CLOSED']
        if (activeTab === 'open') {
          selectedStatuses = ['DRAFT', 'OPEN']
        }
        let paginationQuery = { status__in: selectedStatuses }
        // Fetch 'paginationQuery' data is exist or not from the session storage
        let sessionStorageQuery = sessionStorage.getItem('paginationQuery')
        // Add pagination query in the session storage
        if (sessionStorageQuery) paginationQuery = JSON.parse(sessionStorageQuery)
        // Fetch 'paginationInfo' data is exist or not from the session storage
        let validatePaginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        let entities = []
        let response = []
        try {
          // API to get the results based on the Query
          entities = await store.dispatch('fetchPcsWithQuery', paginationQuery)
          response = this.$store.getters.getPcs || []

          // Check and assign the response data
          if (!validatePaginationData) {
            validatePaginationData = response.sort((a, b) => b.id - a.id)
          }
          // Check unique data is exist or not
          if (validatePaginationData) sessionStorage.setItem('paginationInfo', JSON.stringify(validatePaginationData))
          else sessionStorage.setItem('paginationInfo', JSON.stringify(response.sort((a, b) => b.id - a.id)))
          // Assign pagination info to the paginationData
          this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        } catch (error) {
          console.error()
        }
        this.disablePrevButton = false
        this.disableNextButton = false
        if (this.paginationData && this.paginationData.length > 0) {
          // To get the current index
          let getIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
          // Check index value is zero then disable prev button
          if (getIndex === 0) {
            if (entities) {
              if (!entities.previous) {
                this.disablePrevButton = true
              }
              if (!entities.next && getIndex === this.paginationData.length - 1) {
                this.disableNextButton = true
              }
              if (entities.previous) {
                paginationQuery['page'] = Number(paginationQuery['page']) - 1
                try {
                  // API to get the results based on the Quey param
                  entities = await store.dispatch('fetchPcsWithQuery', paginationQuery)
                  response = this.$store.getters.getPcs || []
                  let totalPaginationData = [...validatePaginationData, ...response]
                  // Update 'paginationInfo' data in the session storage
                  sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                  // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                  this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                  sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
                } catch (error) {
                  console.error()
                }
              }
            }
          } else if (getIndex === this.paginationData.length - 1) {
            // Check next available page is exist or not
            if (!entities || !entities.next) {
              this.disableNextButton = true
            } else {
              paginationQuery['page'] = Number(paginationQuery['page']) + 1
              try {
                // API to get the results based on the Quey param
                entities = await store.dispatch('fetchPcsWithQuery', paginationQuery)
                response = this.$store.getters.getPcs || []
                let totalPaginationData = [...validatePaginationData, ...response]
                // Update 'paginationInfo' data in the session storage
                sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
              } catch (error) {
                console.error()
              }
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        getPcs: 'getPcs',
        getPcById: 'getPcById',
        getLineById: 'getLineById',
        getPcLines: 'getPcLines',
        getPoLines: 'getPoLines',
        getVendorById: 'getVendorById',
        getPcLinesByTransactionId: 'getPcLinesByTransactionId',
        getPeriodById: 'getPeriodById',
        currentPeriod: 'getCurrentPeriod',
        getAccountById: 'getAccountById',
        getAccountBalanceByCode: 'getAccountBalanceByCode',
        getBankByBatchId: 'getBankByBatchId',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions',
        checkIfUserHasAnyOfThePermissions: 'checkIfUserHasAnyOfThePermissions'
      }),
      selectedPeriod () {
        const pc = this.getPcById(this.$route.params.id)
        if (pc && pc.period && this.getPeriodById(pc.period).id) {
          return this.getPeriodById(pc.period)
        }
      },
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_pettycash', 'entry.add_pettycash'])
      },
      hasPostPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_pettycash']) && this.checkIfUserHasAnyOfThePermissions(['entry.post_pettycash', 'auth.post_transactions'])
      },
      hasEditPermission () {
        if (['POSTED', 'CLOSED'].includes(this.originalHeader.status)) return this.hasPostPermission
        else return this.hasCreatePermission
      },
      hasDeletePermission () {
        return this.hasCreatePermission && this.checkIfUserHasRequiredPermissions(['entry.delete_pettycash'])
      },
      hasCreateBatchPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_batch', 'entry.add_batch'])
      },
      hasReadPermission () {
        let readPermission = ['entry.view_pettycash']
        return this.checkIfUserHasRequiredPermissions(readPermission)
      },
      hasPermission () {
        return {
          read: this.hasReadPermission,
          create: this.hasCreatePermission,
          edit: this.hasEditPermission,
          delete: this.hasDeletePermission,
          post: this.hasPostPermission
        }
      },
      fields () {
        const c = this.getPcById(this.$route.params.id)
        let fields = {
          vendor: {
            inputFields: [
              {
                name: 'vendor',
                label: 'Vendor',
                dataType: 'string',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                required: true,
                triggerOnFocus: false,
                queryData: { endpoint: 'vendors', params: { active: 'True', petty_cash_enabled: 'True' } },
                msg: 'Please select a vendor',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) && this.userCanCreateVendor
              }
            ],
            displayFields: [
              {
                name: 'vendor',
                label: 'Type',
                value: this.form.vendor.value ? this.getVendorById(this.form.vendor.value).entity_type : ''
              },
              {
                name: 'vendor',
                label: 'Work State',
                value: this.vendorWorkState
              }
            ]
          },
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                required: true,
                triggerOnFocus: false,
                queryData: { endpoint: 'batches', params: { active: true } },
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) && this.hasCreateBatchPermission,
                msg: 'Please select a batch'
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          pcData: {
            inputFields: [
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission,
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'number',
                label: 'Envelope Number',
                dataType: 'string',
                fieldType: 'input',
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission,
                required: true
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                msg: 'Please specify a date'
              },
              {
                name: 'effective_date',
                label: 'Effective Date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                fieldType: 'date'
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                remote: false,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              },
              {
                name: 'amount_decimal',
                label: 'Envelope Amount',
                dataType: 'string',
                fieldType: 'money',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                isMoney: true
              },
              {
                name: 'advanced_amount_decimal',
                label: 'Advanced Amount',
                dataType: 'string',
                fieldType: 'money',
                required: false,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                isMoney: true
              },
              {
                name: 'amount_beginning_pc_decimal',
                label: 'Beginning PC Bal',
                dataType: 'string',
                fieldType: 'money',
                disabled: !this.hasEditPermission,
                required: false,
                hidden: true,
                isMoney: true
              },
              {
                name: 'amount_remaining_pc_decimal',
                label: 'Remaining PC Bal',
                dataType: 'string',
                fieldType: 'money',
                disabled: !this.hasEditPermission,
                required: false,
                hidden: true,
                isMoney: true
              },
              {
                name: 'reimbursed_amount_decimal',
                label: 'Reimbursed Amount',
                dataType: 'string',
                fieldType: 'input',
                required: false,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status),
                hidden: true,
                isMoney: true
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Transaction #',
                value: c.ledger || ''
              },
              {
                label: 'Date created',
                value: c.created ? this.formatDateToLocale(c.created) : ''
              },
              {
                label: 'Date posted',
                value: c.time_posted ? this.formatDateToLocale(c.time_posted) : ''
              },
              {
                label: 'Status',
                value: c.status || ''
              },
              {
                name: 'runningTotal',
                label: 'Total Distributed',
                prefix: this.currency ? this.currency.symbol : ''
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.pcData.inputFields[4].options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
          fields.pcData.inputFields[4].options.push({
            label: `Ending ${this.selectedPeriod.end}`,
            value: this.selectedPeriod.id,
            selected: true
          })
        }
        return fields
      },
      isRecon () {
        if (this.batchAttributes.bank) {
          let lines = Object.values(this.getPcLinesByTransactionId(this.$route.params.id))
          return lines.filter(l => (l.recon !== null && (l.bank === this.batchAttributes.bank.id))).length > 0
        }
      },
      hasDcs () {
        return this.form.status === 'POSTED' &&
          this.originalLines.some(line => line && line.form && line.form.offset_by)
      },
      // Using computed objects to get numeric values and to watch changes without haveing to watch entire form
      amount_envelope () {
        if (!this.form.amount_decimal || isNaN(this.form.amount_decimal)) return 0
        return parseFloat(this.form.amount_decimal)
      },
      advanced_amount () {
        if (!this.form.advanced_amount_decimal || isNaN(this.form.advanced_amount_decimal)) return 0
        return parseFloat(this.form.advanced_amount_decimal)
      },
      reimbursed_amount () {
        if (!this.form.reimbursed_amount_decimal || isNaN(this.form.reimbursed_amount_decimal)) return 0
        return parseFloat(this.form.reimbursed_amount_decimal)
      },
      amount_pc_beginning () {
        if (!this.form.amount_beginning_pc_decimal || isNaN(this.form.amount_beginning_pc_decimal)) return 0
        return parseFloat(this.form.amount_beginning_pc_decimal)
      },
      amount_pc_balance () {
        let balance = this.amount_pc_beginning - this.amount_envelope + this.advanced_amount + this.reimbursed_amount
        return parseFloat(balance)
      }
    },
    watch: {
      vendorNumberVerifier () {
        this.trxAlreadyExists = false
        if (this.trxAlreadyExistsMsg) this.trxAlreadyExistsMsg.close()
        clearTimeout(this.vendorNumberCheckTimeout)
        this.vendorNumberCheckTimeout = setTimeout(() => {
          this.checkIfTrxExists()
        }, 1000)
      },
      /**
       * Watches the PC store for any new data returned by the API. When this transaction is updated,
       * the API will return a fresh copy, which will hit the store and trigger the following updates
       * to this component.
       */
      getPcs () {
        const newHeader = this.getPcById(this.originalHeader.id)
        if (newHeader && Object.keys(newHeader).length) {
          this.originalHeader = Object.assign({}, newHeader)
          this.updateHeaderStatusField()
          this.readOnly = !['DRAFT', 'OPEN', 'AUDITED'].includes(this.originalHeader.status) || !this.hasEditPermission
        }
      },
      /**
       * Keeps an eye on which vendor is currently selected, fetches any open PO lines
       * for said vendor, and updates the PO line options in the distribution lines "relieves"
       * select dropdown.
       */
      currentVendorSelection () {
        this.getVendorOpenPoLines()
        if (this.currentVendorSelection && this.dataLoaded) {
          this.setPcBalance(this.form.vendor.value)
        }
      },
      /**
       * Watches the PC store's lines property for any new or updated distribution lines.
       * This is needed in order to render offset lines created by the API on the fly.
       */
      getPcLines () {
        const recent = () => {
          let incoming = Object.values(this.getPcLinesByTransactionId(this.$route.params.id))
          return this.buildLinesWithDcs(incoming)
        }
        if (this.ready && (JSON.stringify(recent()) !== JSON.stringify(this.originalLines))) { // this.ready prevents this logic from running when component is created
          this.originalLines = recent()
          this.lines = recent()
          if (this.$refs && this.$refs['distribution-lines']) {
            this.$refs['distribution-lines'].rebuildLines()
          }
        }
        this.ready = !this.isSaving
      },
      /**
       * Determines whether the transaction's amount has changed
       */
      headerDeltas () {
        this.amountHasChanged = Object.keys(this.headerDeltas).includes('amount_decimal')
      },
      // If these fields change, update the remaining pc balance and related distribution line
      amount_envelope (newValue, oldValue) {
        if ((newValue) || newValue === 0 || newValue === '') {
          this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
          this.getSpecialPcLines(this.lines)
          this.addEnvelopeLineItem()
        }
      },
      advanced_amount (newValue, oldValue) {
        if ((newValue) || newValue === 0 || newValue === '') {
          this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
          this.getSpecialPcLines(this.lines)
          this.addAdvanceLineItem()
        }
      },
      reimbursed_amount (newValue, oldValue) {
        if ((newValue) || newValue === 0 || newValue === '') {
          this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
          this.getSpecialPcLines(this.lines)
          this.addReimbursementLineItem()
        }
      },
      dataLoaded () {
        if (!this.dataLoaded) return
        this.updateForm(this.form)
        if (this.currentVendorSelection && !(this.form.amount_beginning_pc_decimal || this.form.amount_remaining_pc_decimal)) {
          this.setPcBalance(this.form.vendor.value)
        }
      }
    },
    /**
     * Things that should be done when the component is created
     */
    async created () {
      await this.customCreated()
      // this.lines = sortLines(this.lines)
      this.transactionIsBalanced = isPcBalanced(this)
      this.updateForm(this.form)
      this.linesChanged()
      this.$store.dispatch('isEditingForm', false)
      this.$store.dispatch('fetchUiSetting', { name: 'UNPOST_PC_TRANSACTIONS' })
      this.createRelievesFieldOptions()
    },
    /**
     * Things that should be done before the route resolves and the component is created
     * @param to
     * @param from
     * @param next
     * @return {Promise<void>}
     */
    async beforeRouteEnter (to, from, next) {
      const { getPcById } = store.getters
      try {
        const resp = await store.dispatch('fetchCompactLinePcsWithQuery', { query: { id: to.params.id, compact_lines: true }, storeLines: true })
        let promises = [
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
          store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
        ]
        if (resp && resp.entities) {
          const deps = await store.dispatch('findDependencies', resp.entities) || []
          promises = [...promises, ...deps]
        }
        await Promise.all(promises)
        const pc = getPcById(to.params.id)
        await getPoLinesToRelieve(pc.id, 'pc')
        await loadInitialData()
        // if (['POSTED', 'CLOSED', 'VOIDED', 'DELETED'].includes(pc.status)) {
        //   await getOffsetDcJeLines(to.params.id, 'pc')
        // }
        promises = [...FindOrFetchBatchAndPeriod(store, pc)]
        if (promises.length) {
          await Promise.all(promises)
        }
        next()
      } catch (e) {
        console.log(e)
        // TODO: notify user
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        sessionStorage.removeItem('paginationInfo')
        sessionStorage.removeItem('paginationQuery')
        await this.$store.dispatch('clearPcState')
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        if (this.trxAlreadyExistsMsg) this.trxAlreadyExistsMsg.close()
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
</style>
